import { connect } from 'dva';

function WithMarkIspPermissions({ children, currentUser, defaultUiSettings }) {
  const hasPermissions = () => {
    return defaultUiSettings.mark_as_isp && defaultUiSettings.mark_as_isp_emails.includes(currentUser.email);
  };

  if (hasPermissions()) {
    return children;
  } else {
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.app.user,
    defaultUiSettings: state.app.defaultUiSettings,
  };
};

export default connect(mapStateToProps)(WithMarkIspPermissions);



// WEBPACK FOOTER //
// ./src/components/Permissions/WithMarkIspPermissions.js